/**
 * Copyright (c) Cody Hicks.
 * Allows user to select and insert either a font-awesome icon or custom Moccasin Creek Kennel icon
 *
 * Version: 1.0
 */
tinymce.PluginManager.add("iconinsert", function (editor, url) {
  var openDialog = function () {
    // Get current selection
    var currentSelection = tinymce.activeEditor.selection.getContent();

    return editor.windowManager.open({
      title: "Select an icon to insert",
      body: {
        type: "panel",
        items: [{
          type: "selectbox",
          name: "icon",
          label: "Select Icon",
          items: [{
            text: "External Link",
            value: "far fa-external-link-square"
          }]
        }]
      },
      buttons: [{
          type: "cancel",
          text: "Close"
        },
        {
          type: "submit",
          text: "Insert",
          primary: true
        }
      ],
      onSubmit: function (api) {
        var data = api.getData();
        // Insert content when the window form is submitted
        tinyMCE.activeEditor.selection.setContent(
          tinyMCE.activeEditor.dom.createHTML("i", {
            class: data.icon
          }) + tinyMCE.activeEditor.dom.createHTML(" ")
        );
        api.close();
      }
    });
  };

  // Add a button that opens a window
  editor.ui.registry.addButton("iconinsert", {
    text: "Icon",
    onAction: function () {
      // Open window
      openDialog();
    }
  });

  // Adds a menu item, which can then be included in any menu via the menu/menubar configuration
  editor.ui.registry.addMenuItem("iconinsert", {
    text: "Icon",
    prependToContext: true,
    onAction: function () {
      // Open window
      openDialog();
    }
  });

  return {
    getMetadata: function () {
      return {
        name: "Example plugin",
        url: "http://exampleplugindocsurl.com"
      };
    }
  };
});